export function setterNullSafety(func) {
  try {
    func();
  } catch (e) {
    console.log(e);
  }
}
